import React, { useState } from 'react'
import { SpinnerCircularFixed } from 'spinners-react';
import axios from 'axios'

const SearchForm = () => {
    const [searchAccount, setSearchAccount] = useState('')
    const [data, setData ] = useState({})
    const [isLoading,  setIsLoading] = useState(false)
    const [downlaod, setDownload] = useState([])
    
    const handSubmit = async(e) =>{
        e.preventDefault()
        setIsLoading(true)
       await axios(`https://abc-transport-rights-issue-22.herokuapp.com/get-account-by-account-no/${searchAccount}`).then((res)=>{
        setData(res.data)
        setIsLoading(false)
        });



       
    }
  return (
    <>
    <section className="project section-padding" id="project">
          <div className="container-fluid">
               <div className="row">

                    <div className="col-lg-12 col-12">

                        <h3 className="mb-5 text-center" data-aos="fade-up">
                            Kindly input your shareholder <strong>{ " "} Account Number {" "} </strong> to get your ABC Transport Plc Rights form. <br/> Thereafter, click on search, then Download PDF.
                         
                        </h3>

                        <form class="contact-form" data-aos="fade-up" data-aos-delay="300" onSubmit={handSubmit}>
                        <div className="row">
                          <div className="col-lg-6 col-sm-6 offset-md-3 searchIcon">
                            <input type="text" className="form-control" name="name" onChange={(e) =>setSearchAccount(e.target.value) } placeholder="Account Number" />
                            <i className="fa fa-search" aria-hidden="true"></i>
                          </div>

                          

                          <div className="col-lg-2 mx-auto col-sm-6">
                            {!isLoading && (<button type="button" class="form-control" id="submit-button" name="submit" onClick={handSubmit}><i className="fa fa-paper-plane" style={{margin: '-4px'}} aria-hidden="true"></i> {" "} Search</button>)}
                            {isLoading && (<button type="button" class="form-control" id="submit-button" name="submit" onClick={handSubmit} disabled> <i className='fa fa-spinner fa-spin' style={{margin: '-4px'}} ></i> Loading...</button>)}
                          </div>
                        </div>
                        </form>

                                                
                        {Object.keys(data).length > 1 && (<div className="col-lg-6 col-sm-6 offset-md-3 pt-50" >

                        <div className="card " style={{width: ''}} >
                        <div className="card-body">
                          <h5 className="card-title">Shareholder Details</h5>
                          <h6 className="card-subtitle mb-2 text-muted">Name: - <span> {data.name}</span></h6> 
                          <h6 className="card-subtitle mb-2 text-muted">Amount Payable:-  <span>  NGN {  data.amountpayable.toLocaleString(undefined, {maximumFractionDigits:2})}</span></h6> 
                          <h6 className="card-subtitle mb-2 text-muted">Rights Due:-  <span> {  data.rightsdue.toLocaleString(undefined, {maximumFractionDigits:2})}</span></h6> 
                          <h6 className="card-subtitle mb-2 text-muted">Units: - <span> { data.units.toLocaleString(undefined, {maximumFractionDigits:2})}</span></h6> 
                          
                          
                          

                          <i className="fa fa-file-pdf-o" aria-hidden="true"></i> <a className='btn btn-primary' role="button"  href={'https://abc-transport-rights-issue-22.herokuapp.com/get-rights-form-by-account-no/'+ searchAccount} target="_blank" class="card-link"><strong><u> Download PDF </u></strong> </a> 
                          
                        </div>
                        </div>

                        </div>) }
          
                        

                      

                    </div>

               </div>
          </div>
     </section>
    </>
  )
}

export default SearchForm